exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tab-btn[data-v-490a4e10]{font-size:12px!important;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-490a4e10","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/headOffice/business/download/list.vue
// module id = 476
// module chunks = 0